import classes from './booking-link.module.scss';
function PoweredByFaces() {
    return <p className={classes.poweredByFaces}>Powered by Faces</p>;
}
export default PoweredByFaces;
